<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="ha_code,ha_yearmonth"
        placeholder="输入编号、月份进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/oa/attendance/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ha_code}}</p>
            <!-- <p class="list-item-muted">{{item.ha_yearmonth}}</p> -->
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ha_yearmonth}}</p>
            <!-- <span
              class="list-item-status"
              :class="{'warning':item.co_status!='已审核'}"
            >{{item.ha_yearmonth}}</span> -->
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}份</label>
      </div>
    </div>

    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="dc_code,had_emname"
        placeholder="输入编号、姓名进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/oa/attendance_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.dc_code}}</p>
            <p class="list-item-muted">{{item.createTime}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.had_deptname}}</p>
            <span
              class="list-item-muted"
            >{{item.had_emname}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}个</label>
      </div>
    </div>
  </div>

</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/hr/hrAttendance/list",
      filters: [
        {
          type: "period",
          name: "ha_yearmonth"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待变更",
              condition: "dc_statuscode='SUBMITTED'"
            },
            {
              value: 2,
              label: "已变更",
              condition: "dc_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 0
      this.listUrl = isChange ? '/api/hr/day/change/list' : '/api/hr/hrAttendance/list'
      this.filters[0].type = isChange ? 'date' : 'period'
      this.filters[0].name = isChange ? 'hr_attendance_day_change.createTime' : 'ha_yearmonth'
      this.isChange = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
};
</script>